import styled from 'styled-components';
import { styleguide } from '../../../theme/styleguide';

export const SessionInfo = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  font-weight: normal !important;
  color: #666666;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  padding: 20px 24px 16px 24px;
  display: flex;
  align-items: center;
  @media (max-width: 650px) {
    padding: 20px 16px 16px 16px;
  }
  > div {
    width: 90%;
    padding: 0 !important;
    margin: 0 0 0 20px;

    &:only-child {
      margin: 0 0 0 45px;
    }
    @media (max-width: 650px) {
      margin: 0 0 0 6%;
    }
  }
  > img {
    align-self: flex-start;
  }
`;

export const Img = styled.img`
  margin-right: 0px;
  position: relative;
  width: 20px;
  height: 20px;
  float: right;
`;

export const SpanText = styled.span`
  margin-right: 0px;
  position: relative;
  width: 95px;
  height: 25px;
  float: right;
  color: #008a00;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: right;
`;

export const SubTitleSpan = styled.span`
  color: #008a00;
  width: 95px;
  height: 25px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  left: 0;
  position: relative;
  text-align: left;
`;

export const ButtonTrash = styled.button`
  border: 0;
  cursor: pointer;
  background: transparent;
  position: relative;
  // width: 48px;
  padding: 8px;
  height: 32px;
  float: right;
  border-radius: 4px;
  color: ${styleguide.colors.blue[100]};
  border: 1px solid ${styleguide.colors.blue[100]};
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 700;

  &:focus {
    border: 2px solid ${styleguide.colors.blue[100]};
    font-weight: 700;
  }
`;
